<template>
  <div class="add">
    <breadcrumb :breadcrumbList="breadcrumbList"></breadcrumb>
    <div class="add-content">
      <add-form></add-form>
    </div>
  </div>
</template>

<script lang="js">
import { defineComponent, reactive, ref } from 'vue'
import Breadcrumb from '@/components/breadcrumb/breadcrumb.vue'
import { breadcrumbList } from './config'
import AddForm from './cpns/add-form/add-form.vue'
export default defineComponent({
  props: {

  },
  components: {
    Breadcrumb,
    AddForm
  },
  setup() {


    return {
      breadcrumbList

    }

  }
})
</script>

<style scoped lang="less">
.add {
  .add-content {
    padding: 20px;
    margin: 20px;
    background-color: #fff;
  }
}
</style>




